'use strict';

var styled = require('styled-components');
var component = require('../../Icon/component.js');
require('react');
require('../../Tooltip/component.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

const IconFilterStyled = styled__default.default(component.Icon) `
  margin-left: 4px;
  width: 1rem;
  height: 1rem;
  color: ${({ $isActive, theme }) => ($isActive ? theme.colors.primary.normal : 'inherit')};
  display: ${({ $isActive }) => ($isActive ? 'block' : 'none')};
`;
const HeaderStyled = styled__default.default.th `
  &:hover {
    ${IconFilterStyled} {
      display: block;
    }
  }
  padding-left: ${({ theme }) => theme.designTokens.tableCellPadding};
  padding-right: ${({ theme }) => theme.designTokens.tableCellPadding};
  padding-bottom: 0.25rem;
  padding-top: 0.75rem;
  text-align: left;
  font-size: ${({ theme }) => theme.typography.fontSize.xs};
  font-weight: ${({ theme }) => theme.typography.fontWeight.normal};
  line-height: 1.5rem;
  color: ${({ theme }) => theme.palette.neutral600};
  position: relative;
  ${({ onClick }) => !!onClick && 'cursor: pointer;'};
  &:first-child {
    padding-left: ${({ theme }) => theme.designTokens.tableFirstColumCellPaddingLeft};
  }
`;
const HeaderContentStyled = styled__default.default.div `
  display: flex;
  align-items: center;
  justify-content: start;
  user-select: none;
`;
const HeaderTitleStyled = styled__default.default.div `
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

exports.HeaderContentStyled = HeaderContentStyled;
exports.HeaderStyled = HeaderStyled;
exports.HeaderTitleStyled = HeaderTitleStyled;
exports.IconFilterStyled = IconFilterStyled;
//# sourceMappingURL=header.styles.js.map
